export const environment = {
    production: true,
    wssEndpoint: 'wss://ondatrack.net/websocket/OndaTrackServices/realtime',
    reportsEndPoint: 'http://ondatrack.net:8080/OndaTrackServices/',
    baseURL: 'https://ondatrack.net/ws/OndaTrackServices/webresources/',
    kmlURL: 'https://ondatrack.net/ws/OndaTrackServices/',
    image: 'https://ondatrack.net/ws/OndaTrackServices/image/',
    logo: 'assets/layout/images/login/logo.png',
    googleMapsApiKey: 'AIzaSyD2OEOQmtMbcyW-Q0UudYu9AgKzSARSRrA',
    monitoringURL: 'https://ondatrack.net/#/monitoring?token='
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts